import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "member-navi" }
const _hoisted_2 = { class: "drawer-header" }
const _hoisted_3 = { class: "user-box" }
const _hoisted_4 = { class: "user-icon" }
const _hoisted_5 = { class: "user-details" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "sub" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import type { NavItem } from '@/config/navigation';

interface Props {
  modelValue: boolean;
  menuItems: NavItem[];
  currentUserName: string;
  bizGubunName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberNavi',
  props: {
    modelValue: { type: Boolean },
    menuItems: {},
    currentUserName: {},
    bizGubunName: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const route = useRoute();

const drawerProxy = computed({
  get: () => props.modelValue,
  set: (v: boolean) => emit('update:modelValue', v)
});

const toggleDrawer = () => {
  drawerProxy.value = !drawerProxy.value;
};

// 현재 경로에 해당하는 메뉴 그룹을 자동으로 열기
const openedGroups = computed(() => {
  const currentPath = route.path;
  const opened: string[] = [];
  
  const findOpenGroups = (items: NavItem[], parentTitle?: string) => {
    for (const item of items) {
      if (item.children) {
        const hasActiveChild = item.children.some(child => {
          if (child.to === currentPath) return true;
          if (child.children) {
            return child.children.some(sub => sub.to === currentPath);
          }
          return false;
        });
        
        if (hasActiveChild) {
          opened.push(item.title);
          // 2단계 하위 메뉴도 확인
          for (const child of item.children) {
            if (child.children?.some(sub => sub.to === currentPath)) {
              opened.push(child.title);
            }
          }
        }
      }
    }
  };
  
  findOpenGroups(props.menuItems);
  return opened;
});

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_app_bar_nav_icon, { onClick: toggleDrawer }),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: drawerProxy.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drawerProxy).value = $event)),
      temporary: "",
      width: "280"
    }, {
      append: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createElementVNode("div", { class: "drawer-footer" }, [
          _createElementVNode("span", { class: "footer-logo" }, "CAION")
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                size: "24",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-domain", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.currentUserName), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(__props.bizGubunName), 1)
            ])
          ])
        ]),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, {
          nav: "",
          density: "comfortable",
          class: "menu-list",
          opened: openedGroups.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuItems, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.title
              }, [
                (!item.children)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      to: item.to,
                      "prepend-icon": item.icon,
                      title: item.title,
                      class: "menu-item",
                      rounded: "lg",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (drawerProxy.value = false))
                    }, null, 8, ["to", "prepend-icon", "title"]))
                  : (_openBlock(), _createBlock(_component_v_list_group, {
                      key: 1,
                      value: item.title
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                          "prepend-icon": item.icon,
                          title: item.title,
                          class: "menu-item",
                          rounded: "lg"
                        }), null, 16, ["prepend-icon", "title"])
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: child.title
                          }, [
                            (!child.children)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 0,
                                  to: child.to,
                                  "prepend-icon": child.icon,
                                  title: child.title,
                                  class: "menu-item sub-item",
                                  rounded: "lg",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (drawerProxy.value = false))
                                }, null, 8, ["to", "prepend-icon", "title"]))
                              : (_openBlock(), _createBlock(_component_v_list_group, {
                                  key: 1,
                                  value: child.title,
                                  "sub-group": ""
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                                      "prepend-icon": child.icon,
                                      title: child.title,
                                      class: "menu-item sub-item",
                                      rounded: "lg"
                                    }), null, 16, ["prepend-icon", "title"])
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (subChild) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: subChild.title,
                                        to: subChild.to,
                                        "prepend-icon": subChild.icon,
                                        title: subChild.title,
                                        class: "menu-item sub-sub-item",
                                        rounded: "lg",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (drawerProxy.value = false))
                                      }, null, 8, ["to", "prepend-icon", "title"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                          ], 64))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value"]))
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["opened"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})